module.exports = __webpack_public_path__ + "img/p2p.6343e1aa.png";